import React from 'react';
import ConnectedModal from 'containers/ConnectedModal';
import FreeTrialWelcomeModalContents from './FreeTrialWelcomeModalContents';
import usePromotionDetails from './usePromotionDetails';

export interface FreeTrialWelcomeModalProps {}

const FreeTrialWelcomeModal: React.FC<FreeTrialWelcomeModalProps> = () => {
  const { modalTitle } = usePromotionDetails();

  return (
    <ConnectedModal name="FreeTrialWelcome" title={modalTitle}>
      <FreeTrialWelcomeModalContents />
    </ConnectedModal>
  );
};

export default FreeTrialWelcomeModal;
